/** @jsxImportSource react */
import { getCitySearchUrl } from '@common/helpers/url';
import { Button } from '@react/system';
import Checkmark from '@sly/icons/react/Checkmark';
import { func, object, string } from 'proptypes';
import React from 'react';

const Thankyou = ({ community, heading, subheading, doneText, onClose }) => {
  let backToSearch = null;
  if (community) {
    const { address, propInfo } = community;
    const { city } = address;
    backToSearch = (
      <>
        <div
          className='mx-l mb-l mt-0'
          data-tp-id='gen-div-301c3c22-4418-4273-bf71-b14c78f300a1'
        >
          While you wait, compare your selection with other communities nearby
        </div>
        <div
          className='mb-l text-center'
          data-tp-id='gen-div-dab265b1-a967-4fe9-9a33-2ebb38a442df'
        >
          <Button
            ghost
            href={getCitySearchUrl({ propInfo, address })}
            data-tp-id='gen-Button-9d3068b5-81f3-4562-b980-e4a2879c7a71'
          >
            Communities In {city}
          </Button>
        </div>
      </>
    );
  }

  return (
    <div
      className='flex w-full flex-col items-center p-l'
      data-tp-id='gen-div-9cc507f3-2d92-479c-a087-fba0be4a2fca'
    >
      <div
        className='mb-l grid grid-cols-[32px_auto] items-center gap-m'
        data-tp-id='gen-div-232d091e-8763-4c22-984e-4ea18d0e922b'
      >
        <Checkmark
          palette='primary'
          size='l'
          className='rounded-full bg-viridian-lighter-90 p-[6px]'
        />
        <h2
          className='font-t-m text-viridian-base'
          data-tp-id='gen-h2-37adeab6-396c-482b-9c07-102c0d9f2757'
        >
          {heading}
        </h2>
      </div>

      <hr className='m-0' />
      <div
        className='mx-l mb-l mt-0'
        data-tp-id='gen-div-5da4143f-ea8f-4e30-9cf8-f6d18c133d31'
      >
        {subheading}
      </div>
      {backToSearch}
      {onClose && (
        <Button
          onClick={onClose}
          kind='jumbo'
          data-tp-id='gen-Button-03315244-6ffc-4842-865b-7d45438710f3'
        >
          {doneText}
        </Button>
      )}
    </div>
  );
};

Thankyou.propTypes = {
  community: object,
  onClose: func,
  heading: string,
  subheading: string,
  doneText: string,
};

Thankyou.defaultProps = {
  heading: 'Thank you!',
  subheading:
    'A Local Expert will reach out to you with local expertise and support to ensure you find the' +
    ' right fit for your needs. There is no cost to you!',
  doneText: 'Done',
};

export default Thankyou;
